<div class="splash-screen-container">
    <div *ngIf="isLoading" class="splash-content">
        <mat-progress-spinner mode="indeterminate" [diameter]="50"></mat-progress-spinner>
        <p class="message">Loading data, please wait...</p>
    </div>

    <div *ngIf="hasError" class="splash-content" @zoomIn>
        <mat-icon class="error-icon">error_outline</mat-icon>
        <h2 class="error-title">Failed to Load Data</h2>
        <p class="message">An unexpected error occurred. Please try again or go back.</p>
        <div class="actions-container">
            <button mat-stroked-button (click)="goBack.emit()">
                Go Back
            </button>
            <button mat-flat-button color="primary" (click)="retry.emit()">
                <mat-icon>refresh</mat-icon>
                <span>Retry</span>
            </button>
        </div>
    </div>
</div>
